<template>
	<div>求助与咨询</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>